import React from 'react'
import TextInput from './TextInput'

export default ({ type = 'integer', ...props }) => (
  <TextInput type="number" step={type === 'decimal' ? 0.01 : 1} {...props} />
)
